
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.grid-wrapper{
  --gap-count:calc(var(--grid-column--max-count) - 1);
  --total-gap-width:calc(var(--gap-count) * var(--grid-layout-column-gap));
  --grid-item--max-width:calc(
    (100% - var(--total-gap-width)) / var(--grid-column--max-count)
  );

  display:grid;
  grid-template-columns:repeat(
    auto-fill,
    minmax(max(var(--grid-item--min-width), var(--grid-item--max-width)), 1fr)
  );
  grid-gap:var(--grid-layout-column-gap);
  grid-horizontal-gap:var(--grid-layout-horizontal-gap);
  grid-vertical-gap:var(--grid-layout-vertical-gap);
  grid-row-gap:var(--grid-layout-row-gap);
  grid-column-gap:var(--grid-layout-column-gap);
  justify-content:center;
}

.equal-height{
  grid-auto-rows:1fr;
}

.equal-height > *{
    height:100%;
  }

.equal-height > * > *{
      height:100%;
    }

.justify-items{
  justify-items:var(--justify-items);
}

.align-items{
  align-items:var(--align-items);
}
`;